"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Box = void 0;

var _recompose = require("recompose");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("./styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var proptypeNumberStringArray = _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.number)]);

var proptypeStringArray = _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.string)]);

var Box = (0, _recompose.compose)((0, _recompose.setPropTypes)({
  m: proptypeNumberStringArray,
  mt: proptypeNumberStringArray,
  mr: proptypeNumberStringArray,
  mb: proptypeNumberStringArray,
  ml: proptypeNumberStringArray,
  mx: proptypeNumberStringArray,
  my: proptypeNumberStringArray,
  p: proptypeNumberStringArray,
  pt: proptypeNumberStringArray,
  pr: proptypeNumberStringArray,
  pb: proptypeNumberStringArray,
  pl: proptypeNumberStringArray,
  px: proptypeNumberStringArray,
  py: proptypeNumberStringArray,
  width: proptypeNumberStringArray,
  as: _propTypes.default.string
}), (0, _recompose.setDisplayName)('Box'))(_styles._Box);
exports.Box = Box;

var _default = (0, _recompose.compose)((0, _recompose.defaultProps)({
  display: 'flex'
}), (0, _recompose.setPropTypes)({
  display: proptypeStringArray,
  flexWrap: proptypeStringArray,
  flexDirection: proptypeStringArray,
  alignItems: proptypeStringArray,
  justifyContent: proptypeStringArray,
  flex: proptypeStringArray,
  order: proptypeNumberStringArray
}), (0, _recompose.setDisplayName)('Flex'))(Box);

exports.default = _default;